<script>
  import { mapGetters } from 'vuex';
  import {
    isUserPlanBasicOrAbove,
    isUserPlanPremiumOrAbove,
    isUserSubscribed,
    isUserNotSubscribed,
    isUserPlanStandardOrBelow,
    isUserPlanPremiumOrBelow,
    PLANS,
    getPlansAboveCurrentPlan,
    didUserSubscribeBeforePlansChanges,
    getPlanLabel,
  } from '@/../functions/src/util/customerStatus.cjs';

  export default {
    computed: {
      ...mapGetters({ userProfile: 'getUserProfile' }),
      userPlan() {
        return PLANS[this.userProfile.customerStatus].label;
      },
    },
    methods: {
      isUserPlanBasicOrAbove,
      isUserPlanPremiumOrAbove,
      isUserSubscribed,
      isUserNotSubscribed,
      isUserPlanStandardOrBelow,
      isUserPlanPremiumOrBelow,
      getPlansAboveCurrentPlan,
      didUserSubscribeBeforePlansChanges,
      getPlanLabel,
    },
    data() {
      return {
        PLANS,
      };
    },
  };
</script>
